import React from 'react';
// -*- mode: jsx;-*-
import { RecurringDonationIllustration } from '../common/RecurringDonationIllustration.js';

let RecurringDonationSection = function (props) {
    return (
        <section className="monthly-section">
            <div className="container">
                <h4>Support teachers and students <span className="no-wrap">with a</span></h4>
                {/* COVID timely messaging */}
                <h2>Monthly Donation</h2>
                <RecurringDonationIllustration/>
                <h3>Choose a new project every month.</h3>
                <p className="subheader">We&rsquo;ll charge you once a month, and you handpick the projects you want to support. <strong>No time to pick?</strong> We&rsquo;ll use your donation to help an urgent teacher request.</p>
                <a className="button-secondary" href={baseURL + 'donors/recurring_donation_landing.html'}>Support teachers monthly</a>

                {/* <h2>Monthly Classroom Gift</h2> */}
                {/* <dc.common.RecurringDonationIllustration/> */}
                {/* <h3>Choose a new project every month.</h3> */}
                {/* <p className="subheader">We&rsquo;ll charge you once a month, and you handpick the projects you want to support. <strong>No time to pick?</strong> We&rsquo;ll use your donation to help other classroom projects.</p> */}
                {/* <a className="button-secondary" href={baseURL + "donors/recurring_donation_landing.html"}>Support classrooms monthly</a> */}
            </div>
        </section>
    );
};
RecurringDonationSection = React.memo(RecurringDonationSection);
export default RecurringDonationSection;
